import { Card, CardHeader, Heading } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";
import { useStore } from "zustand";

import { InputComponent } from "../../components/common/Input";
import { ActionBar } from "../../components/workbench/ActionBar";
import { PdfWorkbenchCard } from "../../components/workbench/PdfWorkbenchCard";
import { workbenchStore } from "../../store/workbench";
import { InputComponentTypes } from "../../types/inputs";

const CardContainer = styled.div`
    display: block;
    margin: 50px auto;
    max-width: 900px;
`;

const ColumnFlex = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 20px;
`;

export const WorkbenchContainer: React.FunctionComponent = () => {
    const [insightTitle, setInsightTitle] = useStore(
        workbenchStore,
        (state) => [state.title, state.setTitle],
    );

    return (
        <section>
            <ActionBar />
            <CardContainer>
                <ColumnFlex>
                    <Card>
                        <CardHeader>
                            <Heading renderAs="h3">Insight Details</Heading>
                        </CardHeader>
                        <InputComponent
                            label="Insight Title"
                            type={InputComponentTypes.TEXT}
                            dimension="insight-title"
                            value={insightTitle}
                            setValue={setInsightTitle}
                        />
                    </Card>
                    <PdfWorkbenchCard />
                </ColumnFlex>
            </CardContainer>
        </section>
    );
};
